"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const lodash_1 = __importDefault(require("lodash"));
const ui = __importStar(require("@mwater/react-library/lib/bootstrap"));
const Widget_1 = __importDefault(require("./Widget"));
const DropdownWidgetComponent_1 = __importDefault(require("./DropdownWidgetComponent"));
const ModalPopupComponent_1 = __importDefault(require("@mwater/react-library/lib/ModalPopupComponent"));
const immer_1 = __importDefault(require("immer"));
/**
 * Table of contents widget that displays the h1, h2, etc entries from all text fields in one widget
 */
class TOCWidget extends Widget_1.default {
    /** Creates a React element that is a view of the widget */
    createViewElement(options) {
        return react_1.default.createElement(TOCWidgetComponent, { design: options.design, onDesignChange: options.onDesignChange ?? undefined, width: options.width, height: options.height, tocEntries: options.tocEntries, onScrollToTOCEntry: options.onScrollToTOCEntry, translate: options.translate });
    }
    // Determine if widget is auto-height, which means that a vertical height is not required.
    isAutoHeight() {
        return true;
    }
    getTranslatableStrings(design, schema) {
        const strings = [];
        if (design.header) {
            strings.push(design.header);
        }
        return strings;
    }
}
exports.default = TOCWidget;
function TOCWidgetComponent(props) {
    const { design, onDesignChange, width, height, tocEntries, onScrollToTOCEntry, translate } = props;
    const [editing, setEditing] = (0, react_1.useState)(false);
    const handleStartEditing = () => {
        setEditing(true);
    };
    const handleEndEditing = () => {
        setEditing(false);
    };
    const renderEditor = () => {
        if (!editing) {
            return null;
        }
        // Create editor
        const editor = react_1.default.createElement(TOCWidgetDesignerComponent, { design: design, onDesignChange: onDesignChange });
        return react_1.default.createElement(ModalPopupComponent_1.default, { showCloseX: true, header: T `Table of Contents Options`, onClose: handleEndEditing }, editor);
    };
    const renderContent = () => {
        return react_1.default.createElement(TOCWidgetViewComponent, { design: design, onDesignChange: onDesignChange, width: width, height: height, tocEntries: tocEntries, onScrollToTOCEntry: onScrollToTOCEntry, translate: translate });
    };
    const dropdownItems = [];
    if (onDesignChange != null) {
        dropdownItems.push({ label: T `Edit`, icon: "pencil", onClick: handleStartEditing });
    }
    // Wrap in a simple widget
    return react_1.default.createElement("div", { onDoubleClick: handleStartEditing },
        onDesignChange != null ? renderEditor() : undefined,
        react_1.default.createElement(DropdownWidgetComponent_1.default, { width: width, height: height, dropdownItems: dropdownItems }, renderContent()));
}
// Displays the contents of the widget
function TOCWidgetViewComponent(props) {
    const { design, onDesignChange, width, height, tocEntries, onScrollToTOCEntry, translate } = props;
    const handleEntryClick = (tocEntry) => {
        return onScrollToTOCEntry?.(tocEntry.widgetId, tocEntry.id);
    };
    const renderTOCEntry = (tocEntry, index) => {
        // Find indentation number (e.g "1.3.2") by counting # backwards that are same level with no level lower
        let level;
        let indentation = "";
        if (design.numbering) {
            // For each level up to the current entry's level
            for (let level = 1; level <= tocEntry.level; level++) {
                let value = 0;
                // Count entries at this level up to current index
                for (let i = 0; i <= index; i++) {
                    const entry = tocEntries?.[i];
                    if (!entry) {
                        continue;
                    }
                    if (entry.level === level) {
                        value++;
                    }
                    else if (entry.level < level) {
                        // Reset counter when we hit a higher level
                        value = 0;
                    }
                }
                indentation += `${value}.`;
            }
            indentation += " ";
        }
        return react_1.default.createElement("div", { key: index, style: { paddingLeft: tocEntry.level * 8 - 8 } },
            react_1.default.createElement("a", { className: "link-plain", onClick: () => handleEntryClick(tocEntry) },
                indentation,
                react_1.default.createElement("span", null, translate(tocEntry.text))));
    };
    // Get border
    const border = (() => {
        switch (design.borderWeight) {
            case 0:
                return "none";
            case 1:
                return "solid 1px #f4f4f4";
            case 2:
                return "solid 1px #ccc";
            case 3:
                return "solid 1px #888";
        }
    })();
    return react_1.default.createElement("div", { style: {
            width,
            height,
            border,
            padding: 5,
            margin: 1
        } },
        react_1.default.createElement("div", { style: { fontWeight: "bold" } }, design.header ? props.translate(design.header) : ""),
        lodash_1.default.map(tocEntries || [], (tocEntry, i) => {
            return renderTOCEntry(tocEntry, i);
        }),
        onDesignChange && (tocEntries || []).length === 0
            ? react_1.default.createElement("div", { className: "text-muted" }, T `Table of Contents will appear here as text blocks with headings are added to the dashboard`)
            : undefined);
}
// Designer for TOC widget options
function TOCWidgetDesignerComponent(props) {
    const { design, onDesignChange } = props;
    // Updates design with the specified changes
    const handleUpdate = (field) => (value) => {
        onDesignChange((0, immer_1.default)(design, draft => {
            draft[field] = value;
        }));
    };
    return react_1.default.createElement("div", null,
        react_1.default.createElement(ui.FormGroup, { label: T `Header` },
            react_1.default.createElement(ui.TextInput, { value: design.header || "", onChange: handleUpdate("header"), placeholder: T `None` })),
        react_1.default.createElement(ui.FormGroup, { label: T `Border` },
            react_1.default.createElement(BorderComponent, { value: design.borderWeight || 0, onChange: handleUpdate("borderWeight") })),
        react_1.default.createElement(ui.FormGroup, { label: T `Numbering` },
            react_1.default.createElement(ui.Radio, { inline: true, value: design.numbering || false, radioValue: true, onChange: handleUpdate("numbering") }, T `On`),
            react_1.default.createElement(ui.Radio, { inline: true, value: design.numbering || false, radioValue: false, onChange: handleUpdate("numbering") }, T `Off`)));
}
// Allows setting border heaviness
function BorderComponent(props) {
    const { value, defaultValue, onChange } = props;
    const currentValue = value != null ? value : defaultValue;
    return react_1.default.createElement("div", null,
        react_1.default.createElement(ui.Radio, { inline: true, value: currentValue, radioValue: 0, onChange: onChange }, T `None`),
        react_1.default.createElement(ui.Radio, { inline: true, value: currentValue, radioValue: 1, onChange: onChange }, T `Light`),
        react_1.default.createElement(ui.Radio, { inline: true, value: currentValue, radioValue: 2, onChange: onChange }, T `Medium`),
        react_1.default.createElement(ui.Radio, { inline: true, value: currentValue, radioValue: 3, onChange: onChange }, T `Heavy`));
}
